import { qrMatrix } from '../lib/qr-matrix';
import { C } from '../theme/palette';

export function QRCode({ size = 60, color = C.navy, value }) {
  let m = null;
  try {
    m = value ? qrMatrix(String(value)) : null;
  } catch (e) {
    m = null;
  }
  if (!m)
    return (
      <div
        style={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          border: '1px solid ' + C.border,
          borderRadius: 4,
          boxSizing: 'border-box',
          padding: 3,
          fontSize: size > 60 ? 8 : 6,
          lineHeight: 1.15,
          color: C.muted,
          fontWeight: 700,
        }}
      >
        QR indisponible
      </div>
    );
  const n = m.length,
    c = size / n,
    r = [];
  for (let y = 0; y < n; y++)
    for (let x = 0; x < n; x++)
      if (m[y][x])
        r.push(
          '<rect x="' +
            (x * c).toFixed(2) +
            '" y="' +
            (y * c).toFixed(2) +
            '" width="' +
            c.toFixed(2) +
            '" height="' +
            c.toFixed(2) +
            '"/>',
        );
  let cross = '';
  if (String(value).slice(0, 3) === 'SPC') {
    const b = size * 0.16,
      p = size / 2,
      aw = b * 0.22,
      al = b * 0.62,
      pad = size * 0.012;
    cross =
      '<rect x="' +
      (p - b / 2 - pad).toFixed(2) +
      '" y="' +
      (p - b / 2 - pad).toFixed(2) +
      '" width="' +
      (b + 2 * pad).toFixed(2) +
      '" height="' +
      (b + 2 * pad).toFixed(2) +
      '" fill="#fff"/>' +
      '<rect x="' +
      (p - b / 2).toFixed(2) +
      '" y="' +
      (p - b / 2).toFixed(2) +
      '" width="' +
      b.toFixed(2) +
      '" height="' +
      b.toFixed(2) +
      '" fill="#000"/>' +
      '<rect x="' +
      (p - aw / 2).toFixed(2) +
      '" y="' +
      (p - al / 2).toFixed(2) +
      '" width="' +
      aw.toFixed(2) +
      '" height="' +
      al.toFixed(2) +
      '" fill="#fff"/>' +
      '<rect x="' +
      (p - al / 2).toFixed(2) +
      '" y="' +
      (p - aw / 2).toFixed(2) +
      '" width="' +
      al.toFixed(2) +
      '" height="' +
      aw.toFixed(2) +
      '" fill="#fff"/>';
  }
  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="' +
    size +
    '" height="' +
    size +
    '" viewBox="0 0 ' +
    size +
    ' ' +
    size +
    '"><rect width="' +
    size +
    '" height="' +
    size +
    '" fill="#fff"/><g fill="' +
    color +
    '">' +
    r.join('') +
    '</g>' +
    cross +
    '</svg>';
  const enc =
    typeof btoa !== 'undefined'
      ? btoa(svg)
      : typeof Buffer !== 'undefined'
        ? Buffer.from(svg).toString('base64')
        : '';
  return (
    <img
      src={'data:image/svg+xml;base64,' + enc}
      style={{ width: size, height: size, display: 'block' }}
      alt="QR"
    />
  );
}
